module.exports = __webpack_public_path__ + "img/icon-market-accessories.6a24b8bd.png";